import t from"styled-components";const e=t.div`
	display: flex;
	justify-content: center;
	align-items: center;
	width: 32px;
	height: 32px;
	cursor: pointer;
`,i=t.div`
	display: flex;
	flex-wrap: wrap;
	column-gap: 5px;
	row-gap: 7px;
	margin: 15px 0px;
`,r=t.div`
	display: inline-block;
	border-radius: 50px;
	background: ${({isChecked:t,theme:e})=>t?e.text.title:"transparent"};
	color: ${({isChecked:t,theme:e})=>t?e.text.inverse:e.text.title};
	border: 1px solid
		${({isChecked:t,theme:e})=>t?e.text.inverse:e.text.title};
	line-height: 1;
	font-size: 9px;
	font-weight: 400;
	text-align: center;
	padding: 7px 15px 6px;
	white-space: nowrap;
	cursor: pointer;
	text-transform: uppercase;
	font-family: 'PP Formula';
`,p=t.div`
	display: grid;
	grid-template-columns: repeat(auto-fit, minmax(24px, 1fr));
	column-gap: 7px;
	row-gap: 7px;
	padding-top: 15px;
	padding-left: 5px;
`,o=t.span`
	cursor: pointer;

	svg {
		width: 24px;
		height: 24px;
		color: ${({theme:t})=>t.text.text};

		${({isSelected:t,theme:e})=>{if(t)return`\n          background: ${e.text.title} !important;\n          color: ${e.text.text}; !important;\n          border-radius: 4px;\n          margin: -5px;\n          padding: 5px;\n        `}}
	}

	&:hover svg {
		margin: -4px;
		padding: 4px;
		border-radius: 3px;
		background: #00000022;
	}
`,n=t.div`
	color: ${({theme:t})=>t.text.text};
	font-size: 12px;
	text-align: center;
	padding-top: 5px;
	font-family: 'PP Formula';
`,a=t.div`
	position: relative;
	border-radius: 8px;

	input {
		background-color: ${({theme:t})=>t.bg.primary} !important;
		outline: none !important;
	}
`,x=t.div`
	position: absolute;
	right: 3px;
	top: 3px;
	color: ${({theme:t})=>t.text.text};
`;export{e as CloseButton,p as IconsContainer,a as InputField,x as InputIcon,n as MessageContainer,i as ProviderOptionsContainer,r as ProviderSelector,o as SingleIconContainer};
